
export const root = {
    outline: {
        width: '2px',
        color: '{content.background}'
    }
};

export default {
    root
};
